import { render } from "./Demo.vue?vue&type=template&id=d2c209e0&scoped=true"
import script from "./Demo.vue?vue&type=script&lang=js"
export * from "./Demo.vue?vue&type=script&lang=js"

import "./Demo.vue?vue&type=style&index=0&id=d2c209e0&lang=css"
import "./Demo.vue?vue&type=style&index=1&id=d2c209e0&scoped=true&lang=css"

import exportComponent from "/Users/romain/Developer/vue-document-editor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2c209e0"]])

export default __exports__